import { combineReducers } from 'redux';
import searchResultReducer from './search-result';
import formSearchReducer from './form-search';
import detailsPublicReducer from './details-public';
import trialControlReducer from './trial-control';

const appointmentsReducer = combineReducers({
  searchResult: searchResultReducer,
  formSearch: formSearchReducer,
  detailsPublic: detailsPublicReducer,
  trialControl: trialControlReducer,
});

export default appointmentsReducer;
